import { CALL_API } from '../middleware';
import {
  CREATE_PAYMENT_LINK,
  CREATE_PAYMENT_LINK_SUCCESS,
  CreatePaymentLinkResponse,
  CancelPaymentResponse,
} from '../types/payment';

export const createPaymentLink =
  (applicationId: string) =>
  async (dispatch: any): Promise<CreatePaymentLinkResponse> => {
    return await dispatch({
      [CALL_API]: {
        url: `/payments/payments/create-payment-link/${applicationId}`,
        method: 'POST',
        types: [CREATE_PAYMENT_LINK_SUCCESS, CREATE_PAYMENT_LINK],
      },
    });
  };

export const cancelPaymentLink =
  (paymentLinkId: string) =>
  async (dispatch: any): Promise<CancelPaymentResponse> => {
    return await dispatch({
      [CALL_API]: {
        url: `/payments/payments/cancel-payment-link/${paymentLinkId}`,
        method: 'GET',
        types: [CREATE_PAYMENT_LINK_SUCCESS, CREATE_PAYMENT_LINK],
      },
    });
  };
